import { defineWidget } from '../../client/lib/contract/helpers'
import { t } from '../../client/i18n'
import { usageRender } from '../../client/families/usage/renders'

/** OpenCode Go rolling-window usage quota (single-window percent card). */
export default defineWidget({
  id: 'usage-rolling',
  name: () => t('widget.usage-rolling.name'),
  desc: () => t('widget.usage-rolling.desc'),
  builtin: false,
  group: 'opencode-go',
  render: usageRender('rolling', 'widget.usage-rolling.name'),
})